export default __webpack_public_path__ + "static/media/Liberia.45b0874c.svg";